

export class SolicitudAtestFitoProductosViewModel {
    public Id: number;
    public IdEstadoSolicitudAtestFito: number = 0;
    public IdTipoSolicitudAtestFito: number = 0;
    public RefAtestFito: string;
    public IdEstadoSolicitudAtestFitoDescripcion: string;
    public IdTipoSolicitudAtestFitoDescripcion: string;
    public CodigoTipoSolicitud: string;
    public SinProductos: boolean;
    public IdTipoCantidadAtestFito: number| null;
    public TProductoSolicitudAtestFitoCollection: TProductoSolicitudAtestFitoViewModel[];
}
export class TProductoSolicitudAtestFitoViewModel {
    public Id: number;
    public IdSolicitudAtestFito: number;
    public CodigoEppo: string;
    public IdEspecie: number;
    public IdBotanicaDescripcion: string;
    public IdPaisDescripcion: string;
    public NombreComun: string;
    public IdGrupo: number;
    public IdForma: number;
    public IdParcelaAtestFito: number | null
    public IdPais: number | null;
    public IdFormaDescripcion: string;
    public Peso: number | null;
    public Volumen: number | null;
    public Unidades: number | null;
    public IdTipoSolicitudAtestFitoDescripcion: string;
    public IdEstadoSolicitudAtestFitoDescripcion: string;
    public CodigoTipoSolicitud: string;
    public Grupo: string;
    public IdEstadoSolicitudAtestFito: number = 0;
    public IdTipoSolicitudAtestFito: number = 0;
    public RefAtestFito: string;
    public IdTipoCantidadAtestFito: number | null;
}






